import { useEffect, useState } from 'react';
import client from '../../api/client';
import Layout from '../../components/Layout';
import './Settings.css';

const ACCENT_COLORS = [
  { name: 'TRACE Blue', value: '#3b82f6' },
  { name: 'Indigo', value: '#6366f1' },
  { name: 'Violet', value: '#8b5cf6' },
  { name: 'Emerald', value: '#10b981' },
  { name: 'Amber', value: '#f59e0b' },
  { name: 'Rose', value: '#f43f5e' },
  { name: 'Slate', value: '#94a3b8' },
  { name: 'White', value: '#f9fafb' },
];

const TIMEZONES = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Phoenix',
  'America/Anchorage',
  'Pacific/Honolulu',
  'Europe/London',
  'Europe/Paris',
  'Europe/Berlin',
  'Asia/Tokyo',
  'Asia/Shanghai',
  'Australia/Sydney',
];

export default function Organization() {
  const [org, setOrg] = useState(null);
  const [loading, setLoading] = useState(true);
  const [orgName, setOrgName] = useState('');
  const [timezone, setTimezone] = useState('America/New_York');
  const [accentColor, setAccentColor] = useState('#3b82f6');
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    try {
      const res = await client.get('/org');
      setOrg(res.data);
      setOrgName(res.data.name);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const save = async () => {
    setError('');
    try {
      await client.put('/org', { name: orgName });
      setSuccess('Settings saved');
      setTimeout(() => setSuccess(''), 3000);
      loadData();
    } catch (err) {
      setError('Failed to save');
    }
  };

  if (loading) return <Layout><div style={{color:'#6b7280', padding:'20px'}}>Loading...</div></Layout>;

  return (
    <Layout>
      <div className="spage-header">
        <h1>Organization</h1>
      </div>

      {success && <div className="spage-success">{success}</div>}
      {error && <div className="spage-error">{error}</div>}

      <div className="spage-section">
        <div className="spage-section-title">General</div>
        <div className="spage-field">
          <label>Shop Name</label>
          <input value={orgName} onChange={e => setOrgName(e.target.value)} />
        </div>
        <div className="spage-field">
          <label>Shop ID</label>
          <div className="spage-static">{org?.slug}</div>
          <div className="spage-hint">This is your login identifier and cannot be changed</div>
        </div>
        <div className="spage-field">
          <label>Timezone</label>
          <select value={timezone} onChange={e => setTimezone(e.target.value)}>
            {TIMEZONES.map(tz => (
              <option key={tz} value={tz}>{tz}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="spage-section">
        <div className="spage-section-title">Accent Color</div>
        <div className="spage-hint" style={{marginBottom: '16px'}}>
          Choose your brand color. TRACE Blue is the default.
        </div>
        <div className="spage-colors">
          {ACCENT_COLORS.map(color => (
            <div
              key={color.value}
              className={`spage-color-swatch ${accentColor === color.value ? 'selected' : ''}`}
              style={{ background: color.value }}
              onClick={() => setAccentColor(color.value)}
              title={color.name}
            />
          ))}
        </div>
        <div className="spage-color-preview">
          Selected: <span style={{ color: accentColor, fontWeight: 600 }}>{ACCENT_COLORS.find(c => c.value === accentColor)?.name}</span>
        </div>
      </div>

      <div className="spage-section">
        <div className="spage-section-title">Plan</div>
        <div className="spage-plan-row">
          <div>
            <div className="spage-plan-name">{org?.plan?.toUpperCase()}</div>
            <div className="spage-hint">Your current plan</div>
          </div>
          <button className="spage-btn-upgrade">Upgrade Plan</button>
        </div>
      </div>

      <button className="spage-btn-save" onClick={save}>Save Changes</button>
    </Layout>
  );
}